module.exports = __webpack_public_path__ + "static/img/2.38f3cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/2.png
// module id = kQhT
// module chunks = 1